export default function HowToPlayModal() {
  return (
    <div className="modal fade mt-5" id="how-to-play-modal" tabIndex={-1} role="dialog" aria-labelledby="how-to-play-modal-label" aria-hidden="true">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header text-center">
            <div id="how-to-play-modal-label" className="w-100">
              <h2 className="modal-title"><i className="fa-solid fa-play"></i> How to Play</h2>
            </div>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <>
              <p>1. Find 2 or more athletes from any sport to add to your line-up.</p>
              <img width="300" src="https://assets.wagedwar.com/wp-content/uploads/2024/07/21071126/Two_athletes.jpg" alt="Two athletes example" />

              <p className="mt-4">2. Choose "More" or "Less" than the projected stat shown.</p>
              <img width="300" height="67" src="https://assets.wagedwar.com/wp-content/uploads/2024/07/21071519/More_Less.jpg" alt="More or Less Example" />

              <p className="mt-4">3. If predicted correctly, you collect the displayed payout! 🤑🤑</p>

              <button className="mt-3 btn btn-outline-danger w-100" data-dismiss="modal" aria-label="Close">Great, let's play!</button>
            </>
          </div>
        </div>
      </div>
    </div>
  )

}